import React from "react";
import {
  Tr,
  Td,
  Button,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Portal,
} from "@chakra-ui/react";
import { NavLink } from "react-router";
import { BOOK, PUBLISHED, OFFLINE } from "../../constants";
import { useBreadcrumbs } from "../../contexts/BreadcrumbProvider"
import "./ProductItem.scss";

export const ProductItem = ({
  productItems,
  catalogId,
  user,
  stripeAccountId,
  isCatalogAdmin
}) => {

  const { addBreadcrumb } = useBreadcrumbs();

  return (
    <>
      {productItems.map((item) => (
        <Tr key={item.id} className="unarchive-tr item-tr" position="relative">
          <Td textDecoration="underline">
            <NavLink to={`/content/${item.id}`} className="catalog-link" onClick={() => addBreadcrumb(item.name, `/content/${item.id}`, false)}>
              {item.name}
            </NavLink>
          </Td>
          <Td
            color={item.productType === BOOK ? "rgb(132, 90, 238)" : "rgb(205, 62, 148)"}
            fontWeight="600"
          >{item.productType}</Td>
          <Td
            color={item.status === PUBLISHED ? "green.500" : "red.500"}
            fontWeight="600"
          >
            {item.status === null ? OFFLINE : item.status}
          </Td>
          <Td
            color={
              typeof item.isAddedToStore === "object"
                ? "red.500"
                : item.isAddedToStore
                  ? "green.500"
                  : "red.500"
            }
            fontWeight="600"
          >
            {typeof item.isAddedToStore === "object"
              ? "Not in store"
              : item.isAddedToStore
                ? "In Store"
                : "Not in store"}
          </Td>
          {(
            isCatalogAdmin && item.status !== PUBLISHED ? true : item.productAdmins
              ? !!item.productAdmins.find((admin) => admin.id === user.id) &&
              item.status !== PUBLISHED
              : false
          ) ? (
            <>
              <Td
                sx={{
                  width: "30px !important",
                }}
              >
                <NavLink to={item.productType === "Course" ? `/updatecourse/${item.id}/${catalogId}` : `/updatebook/${item.id}/${catalogId}`} onClick={() => addBreadcrumb(`${item.name}`, item.productType === "course" ? "/updatecourse" : "/updatebook", false)}>
                  <Button colorScheme="blue" variant="outline">Edit</Button>
                </NavLink>
              </Td>
            </>
          ) : (
            <Td
            sx={{
              width: "30px !important",
            }}
          >
            <Button colorScheme="blue" variant="outline" disabled>Edit</Button>
          </Td>
          )}
        </Tr>
      ))}
    </>
  );
};
